import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

import type { CrmObject } from "../../generated/graphql";

export type CrmRecordRef = { object: CrmObject; salesforceId: string };

/** The CRM record the surrounding content belongs to, null outside any record. */
export const CrmRecordContext = createContext<CrmRecordRef | null>(null);

export const useCrmRecord = (): CrmRecordRef | null => useContext(CrmRecordContext);

type CrmRecordProviderProps = CrmRecordRef & { children: ReactNode };

export const CrmRecordProvider = ({ object, salesforceId, children }: CrmRecordProviderProps) => {
  const value = useMemo(() => ({ object, salesforceId }), [object, salesforceId]);
  return <CrmRecordContext.Provider value={value}>{children}</CrmRecordContext.Provider>;
};
